import { GET_SUBSIDY_FILES } from './actions'
import createReducer from '../../middlewares/api/createReducer'

const subsidyFiles = createReducer(GET_SUBSIDY_FILES)

export default subsidyFiles
